import { MacrocategoriaProdotto } from './product/product.models';
import { Environments } from './config/env-endpoints';
import { BaseUtag, UtagModuloAction, UtagModuloCap, UtagModuloInformazioni, UtagModuloProfiloUtente, SurveyState, SurveyStep } from '../assets/survey/survey-models';
import { LoginLocalStorageData } from './header.models';
import Utils from './utils';
declare global {
    interface Window {
        utag: any;
        php_pars: any;
        utag_queue: any;
    }
}
export class TrackingUtils {
    constructor() {

    }
    private user: LoginLocalStorageData = JSON.parse(localStorage.getItem('info_utente_reducer'));

    private getModuloInformazioniBase(page_name: string, previous_page_name: string, page_id: string, product_category?: string): UtagModuloInformazioni {
        if (!previous_page_name) {
            //recupero il last page name da localstorage
            if (document.referrer) {
                //considero il last page name solo se il referrer è dello stesso dominio in quello in cui sono
                //aka voglio evitare di inserire un lastpagename vecchio in caso in cui l'utente sia uscito dalla navigazione di unipolhoem
                if (document.referrer.toLowerCase().includes(window.location.protocol + '//' + window.location.host?.toLowerCase() + '/'))
                    previous_page_name = localStorage.getItem('homeLastPageName');
            }
        }
        localStorage.setItem('homeLastPageName', page_name);
        return {
            page_environment: window.php_pars.analytics_environment,
            login_status: this.user?.info_utente ? "logged" : "not logged",
            page_breadcrumbs: window.php_pars.post_info?.breadcrumb,
            page_id: page_id,
            page_name: page_name,
            page_url: window.location.href,
            previous_pagename: previous_page_name,
            referring_url: document.referrer,
            product_category: product_category
        }
    }
    private getModuloProfiloUtente(): UtagModuloProfiloUtente {
        const email: string = this.user?.info_utente?.recupera_info_utente?.result?.email;
        const idcrm: string = this.user?.info_utente?.recupera_info_utente?.result?.idAnagrafica;
        const cfPiva: string = this.user?.info_utente?.recupera_info_utente?.result?.cfPiva;
        const userType: "pf" | "pg" = this.user?.info_utente?.recupera_stato_account?.result?.tipo?.toLowerCase() as "pf" | "pg";
        
        const phoneNumber: string = this.user?.info_utente?.recupera_info_utente?.result?.numeroTelefono;

        return {
            user_crm_id: idcrm ?? "",
            user_email: email ? Utils.encodeMD5(email) : "", //Da vedere se togliere l'encoding qui o meno
            user_hash_cf: cfPiva ? Utils.encodeMD5(cfPiva) : "",
            user_type: userType ?? "", //arriva uppercase da localstorage
            
            user_phone_number: phoneNumber ?? "",
        }
    }
    private getModuloCap(cap: string): UtagModuloCap {
        return {
            cap: cap
        }
    }
    getModuloAction(action_name: string, action_effect: string, position: "top" | "center" | "bottom", type = "preventivatore" ): UtagModuloAction {
        return {
            action_tech: "click",
            action_type: type,
            action_name: action_name,
            action_element_position: position,
            action_element_type: "button",
            action_effect: action_effect,
        }
    }
    //questionario

    public async trackSurveyStep(state: SurveyState, loadedStep: SurveyStep, idMestiere: string): Promise<void> {
        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente & UtagModuloCap = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`vetrina:preventivatore:riparazione:domanda step${state.paths.length + 1}`, state.paths.length > 0 ? `vetrina:preventivatore:riparazione:domanda step${state.paths.length}` : '', idMestiere ?? loadedStep.question ?? loadedStep.name),
            ...this.getModuloProfiloUtente(),
            ...this.getModuloCap(state.insertedCap ?? "")
        }
        console.log("tracking step survey...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    //prodotto

    public async trackPreShowPrice(macroCategoria: MacrocategoriaProdotto, idProdotto: string) {

        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`preventivatore:${macroCategoria}:pre showprice`, "", idProdotto, macroCategoria),
            ...this.getModuloProfiloUtente()
        }
        console.log("tracking pre showprice...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    public async trackPostShowPrice(macroCategoria: MacrocategoriaProdotto, idProdotto: string, cap: string) {
        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente & UtagModuloCap = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`preventivatore:${macroCategoria}:showprice`, "", idProdotto, macroCategoria),
            ...this.getModuloProfiloUtente(),
            ...this.getModuloCap(cap)
        }
        console.log("tracking post showprice...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    public async trackPostShowPriceFornitura(macroCategoria: MacrocategoriaProdotto, idProdotto: string, cap: string,) {
        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente & UtagModuloCap = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`preventivatore:${macroCategoria}:showprice fornitura`, "", idProdotto, macroCategoria),
            ...this.getModuloProfiloUtente(),
            ...this.getModuloCap(cap)
        }
        console.log("tracking post showprice fornitura...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    public async trackProductUnavailableCoverage(macroCategoria: MacrocategoriaProdotto, idProdotto: string, cap: string) {
        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente & UtagModuloCap = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`preventivatore:${macroCategoria}:servizio non coperto`, "", idProdotto, macroCategoria),
            ...this.getModuloProfiloUtente(),
            ...this.getModuloCap(cap)
        }
        console.log("tracking post unvailable coverage product...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    public async trackSurveyUnavailableCoverage(state: SurveyState, cap: string, idMestiere: string) {
        const utag_data: BaseUtag & UtagModuloInformazioni & UtagModuloProfiloUtente & UtagModuloCap = {
            virtual: "page",
            ...this.getModuloInformazioniBase(`vetrina:preventivatore:riparazione:servizio non coperto`, state.paths.length > 0 ? `vetrina:preventivatore:riparazione:domanda step${state.paths.length}` : '', idMestiere),
            ...this.getModuloProfiloUtente(),
            ...this.getModuloCap(cap)
        }
        console.log("tracking post unvailable coverage survey...", utag_data);
        if (window.utag?.view) {
            return window.utag?.view(utag_data);
        }else{
            window.utag_queue = utag_data;
        }
    }
    public async trackProductCapCheckClick() {
        const utag_data: BaseUtag & UtagModuloAction = {
            virtual: "action",
            ...this.getModuloAction("inserisci cap", "calcola prezzo", "bottom")
        }
        console.log("tracking calcola prezzo...", utag_data);
        if (window.utag?.link) {
            return window.utag?.link(utag_data);
        }
    }
    public async trackAcquista() {
        const utag_data: BaseUtag & UtagModuloAction = {
            virtual: "action",
            ...this.getModuloAction("intenzione di acquisto", "continua acquisto", "bottom")
        }
        console.log("tracking acquista...", utag_data);
        if (window.utag?.link) {
            return window.utag?.link(utag_data);
        }
    }
    public trackSurveySupportButton(type: string) {
        const utag_data: BaseUtag & UtagModuloAction = {
            virtual: "action",
            ...this.getModuloAction(type, "richiedi assistenza", "bottom", "assistenza")
        }
        console.log(`tracking supporto ${type}...`, utag_data);
        if (window.utag?.link) {
            return window.utag?.link(utag_data);
        }
    }
}